// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer__footer--1HuPR","links":"Footer__links--14wDV"};